import { Injectable } from '@angular/core';


import { BsModalService } from 'ngx-bootstrap/modal';
import { BlockedSlotInfoDetailsComponent } from '../containers/blocked-slot-info-details/blocked-slot-info-details.component';
import { CourtBookingInfoDetailsComponent } from '../containers/court-booking-info-details/court-booking-info-details.component';
import { CourtClassInfoDetailsComponent } from '../containers/court-class-info-details/court-class-info-details.component';

@Injectable({
    providedIn: 'root'
})
export class CourtEventInfoLauncherService {
    constructor(
        private readonly bsModalService: BsModalService
    ) { }

    openBlockedSlotInfo(blockedSlotId: string) {
        return this.bsModalService.show(BlockedSlotInfoDetailsComponent, {
            initialState: {
                blockedSlotId: blockedSlotId
            }
        });
    }

    openCourtBookingInfo(courtBookingId: string) {
        return this.bsModalService.show(CourtBookingInfoDetailsComponent, {
            initialState: { courtBookingId: courtBookingId }
        });
    }

    openCourtClassInfo(courtClassId: string) {
        return this.bsModalService.show(CourtClassInfoDetailsComponent, {
            initialState: { courtClassId: courtClassId }
        });
    }
}
